<!--<app-login-header></app-login-header>-->

<!--<div class="page-container login-wrapper">-->

<!--  &lt;!&ndash; Page content &ndash;&gt;-->
<!--  <div class="page-content">-->

<!--    &lt;!&ndash; Main content &ndash;&gt;-->
<!--    <div class="content-wrapper">-->

<!--      <div class="row justify-content-center">-->
<!--        <div class="col-lg-6 col-md-6 col-sm-10 col-12 text-center">-->
<!--          <div style="color: #fff; font-size: 20px; font-weight: 900; line-height: normal;">-->
<!--            CENTRAL SOFTWARE<br/>-->
<!--            OF<br/> ONLINE CONTINUOUS EMISSION / EFFLUENT <br/>MONITORING SYSTEM-->
<!--          </div>-->
<!--          <div style="margin-top: 5%;">-->
<!--            <img [src]="'assets/images/' + logo" style="width: 20%;">-->
<!--          </div>-->
<!--          <div style="margin-top: 6%; margin-bottom: 6%; font-size: 25px; color: #fff; font-weight: 900;">-->
<!--            {{ stateCode }}-->
<!--          </div>-->

<!--          <div>-->
<!--            <div *ngIf="isLoginError" class="alert alert-danger">-->
<!--              <strong>Error! </strong> {{ errorMsg }}-->
<!--            </div>-->

<!--            <form autocomplete="off" [formGroup]="loginForm" class="mx-auto" style="width: 70%;" novalidate (ngSubmit)="loginUser()">-->

<!--              <div class="mb-3">-->
<!--                <div class="form-check form-check-inline">-->
<!--                  <input [attr.autocomplete]="'off'" autocomplete="off" pattern="^[^<>]*$" formControlName="userType" type="radio"-->
<!--                         value="pcb" name="userType" class="form-check-input" checked>-->
<!--                  <label class="form-check-label text-white fw-bold fs-6" *ngIf="state == 'Tamil Nadu'">PCB Login</label>-->
<!--                  <label class="form-check-label text-white fw-bold fs-6" *ngIf="state == 'Haryana'">PCB Login</label>-->
<!--                  <label class="form-check-label text-white fw-bold fs-6" *ngIf="state == 'Delhi'">DPCC Login</label>-->
<!--                  <label class="form-check-label text-white fw-bold fs-6" *ngIf="state == 'Bihar'">PCB Login</label>-->
<!--                  <label class="form-check-label text-white fw-bold fs-6" *ngIf="state == 'Punjab'">PCB Login</label>-->
<!--                </div>-->

<!--                <div class="form-check form-check-inline">-->
<!--                  <input [attr.autocomplete]="'off'" autocomplete="off" pattern="^[^<>]*$" formControlName="userType" type="radio"-->
<!--                         value="industry" name="userType" class="form-check-input">-->
<!--                  <label class="form-check-label text-white fw-bold fs-6">Industry Login</label>-->
<!--                </div>-->

<!--                <div class="form-check form-check-inline">-->
<!--                  <input [attr.autocomplete]="'off'" autocomplete="off" pattern="^[^<>]*$" formControlName="userType" type="radio"-->
<!--                         value="vendor" name="userType" class="form-check-input">-->
<!--                  <label class="form-check-label text-white fw-bold fs-6">Vendor Login</label>-->
<!--                </div>-->

<!--                <div *ngIf="loginForm.controls['userType'].errors && !loginForm.controls['userType'].pristine">-->
<!--                  <div [hidden]="!loginForm.controls['userType'].errors.required" class="alert alert-danger">-->
<!--                    User type is required.-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->

<!--              <div class="mx-auto" style="width: 75%;">-->
<!--                <div class="mb-3">-->
<!--                  <input [attr.autocomplete]="'off'" autocomplete="off" pattern="^[^<>]*$" formControlName="name" type="text"-->
<!--                         class="form-control" placeholder="Login ID">-->
<!--                  <div *ngIf="loginForm.controls['name'].errors && !loginForm.controls['name'].pristine">-->
<!--                    <div [hidden]="!loginForm.controls['name'].errors.required" class="alert alert-danger">-->
<!--                      Login Id is required.-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->

<!--                <div class="mb-3">-->
<!--                  <input [attr.autocomplete]="'off'" autocomplete="off" pattern="^[^<>]*$" formControlName="password" type="password"-->
<!--                         class="form-control" placeholder="Password">-->
<!--                  <div *ngIf="loginForm.controls['password'].errors && !loginForm.controls['password'].pristine">-->
<!--                    <div [hidden]="!loginForm.controls['password'].errors.required" class="alert alert-danger">-->
<!--                      Password is required.-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->

<!--                <div class="row g-0 mb-3 captcha-cont">-->
<!--                  <div class="col-md-6 d-flex align-items-center bg-light px-2">-->
<!--                    <canvas id="myCanvas" width="130" height="40"></canvas>-->
<!--                    <div class="p-2 cursor-pointer" (click)="generateCaptcha()" role="button" tabindex="0">-->
<!--                      <svg width="16" height="16" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">-->
<!--                        <path d="M17.65,6.35C16.2,4.9 14.21,4 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20C15.73,20 18.84,17.45 19.73,14H17.65C16.83,16.33 14.61,18 12,18A6,6 0 0,1 6,12A6,6 0 0,1 12,6C13.66,6 15.14,6.69 16.22,7.78L13,11H20V4L17.65,6.35Z"/>-->
<!--                      </svg>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                  <div class="col-md-6 ps-2">-->
<!--                    <input autocomplete="off" pattern="^[^<>]*$" formControlName="captcha"-->
<!--                           type="text" class="form-control" placeholder="Enter Captcha">-->
<!--                  </div>-->
<!--                </div>-->

<!--                <div>-->
<!--                  <div *ngIf="loginForm.controls['captcha'].errors && !loginForm.controls['captcha'].pristine">-->
<!--                    <div [hidden]="!loginForm.controls['captcha'].errors.required" class="alert alert-danger">-->
<!--                      Captcha is required.-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->

<!--                <div>-->
<!--                  <button type="submit"-->
<!--                          class="btn btn-rounded w-75"-->
<!--                          style="background-color: #fff; color: #00B06C; font-weight: 500;">-->
<!--                    SIGN IN-->
<!--                    <i *ngIf="isLoader" class="fa fa-spinner fa-spin"></i>-->
<!--                  </button>-->
<!--                </div>-->

<!--              </div>-->
<!--            </form>-->

<!--          </div>-->
<!--        </div>-->
<!--      </div>-->

<!--    </div>-->
<!--  </div>-->
<!--</div>-->

<!--<app-footer></app-footer>-->


<app-login-header></app-login-header>

<div class="page-container login-wrapper">
  <!-- Page content -->
  <div class="page-content">
    <!-- Main content -->
    <div class="content-wrapper">
      <div class="row justify-content-center">
        <div class="col-lg-6 col-md-6 col-sm-10 col-12 text-center">
          <div style="color: #fff; font-size: 20px; font-weight: 900; line-height: normal;">
            CENTRAL SOFTWARE<br/>
            OF<br/> ONLINE CONTINUOUS EMISSION / EFFLUENT <br/>MONITORING SYSTEM
          </div>
          <div style="margin-top: 5%;">
            <img [src]="'assets/images/' + logo" style="width: 20%;">
          </div>
          <div style="margin-top: 6%; margin-bottom: 6%; font-size: 25px; color: #fff; font-weight: 900;">
            {{ stateCode }}
          </div>

          <div>
            <div *ngIf="isLoginError" class="alert alert-danger">
              <strong>Error! </strong> {{ errorMsg }}
            </div>

            <form autocomplete="off" [formGroup]="loginForm" class="mx-auto" style="width: 70%;" novalidate (ngSubmit)="encryptPassword()">
              <!-- Hidden Dummy Fields -->
              <input type="text" style="display: none; height: 0; width: 0; opacity: 0; position: absolute; left: -9999px;" aria-hidden="true">
              <input type="password" style="display: none; height: 0; width: 0; opacity: 0; position: absolute; left: -9999px;" aria-hidden="true">

              <div class="mb-3">
                <div class="form-check form-check-inline">
                  <input [attr.autocomplete]="'off'" autocomplete="off" pattern="^[^<>]*$" formControlName="userType" type="radio"
                         value="pcb" name="userType" class="form-check-input" checked>
                  <label class="form-check-label text-white fw-bold fs-6" *ngIf="state == 'Tamil Nadu'">PCB Login</label>
                  <label class="form-check-label text-white fw-bold fs-6" *ngIf="state == 'Haryana'">PCB Login</label>
                  <label class="form-check-label text-white fw-bold fs-6" *ngIf="state == 'Delhi'">DPCC Login</label>
                  <label class="form-check-label text-white fw-bold fs-6" *ngIf="state == 'Bihar'">PCB Login</label>
                  <label class="form-check-label text-white fw-bold fs-6" *ngIf="state == 'Punjab'">PCB Login</label>
                </div>

                <div class="form-check form-check-inline">
                  <input [attr.autocomplete]="'off'" autocomplete="off" pattern="^[^<>]*$" formControlName="userType" type="radio"
                         value="industry" name="userType" class="form-check-input">
                  <label class="form-check-label text-white fw-bold fs-6">Industry Login</label>
                </div>

                <div class="form-check form-check-inline">
                  <input [attr.autocomplete]="'off'" autocomplete="off" pattern="^[^<>]*$" formControlName="userType" type="radio"
                         value="vendor" name="userType" class="form-check-input">
                  <label class="form-check-label text-white fw-bold fs-6">Vendor Login</label>
                </div>

                <div *ngIf="loginForm.controls['userType'].errors && !loginForm.controls['userType'].pristine">
                  <div [hidden]="!loginForm.controls['userType'].errors.required" class="alert alert-danger">
                    User type is required.
                  </div>
                </div>
              </div>

              <div class="mx-auto" style="width: 75%;">
                <div class="mb-3">
                  <input
                    autocomplete="off"
                    formControlName="name"
                    type="text"
                    class="form-control"
                    placeholder="Login ID"
                    [attr.autocomplete]="'no-fill'"
                  >
                  <div *ngIf="loginForm.controls['name'].errors && !loginForm.controls['name'].pristine">
                    <div [hidden]="!loginForm.controls['name'].errors.required" class="alert alert-danger">
                      Login Id is required.
                    </div>
                  </div>
                </div>

                <div class="mb-3">
                  <input
                    [name]="'pwd-' + generateRandomFieldName()"
                    autocomplete="new-password"
                    formControlName="password"
                    type="password"
                    class="form-control"
                    placeholder="Password"
                    readonly
                    (focus)="removeReadOnly($event)"
                    [attr.autocomplete]="'new-password'"
                  >
                  <div *ngIf="loginForm.controls['password'].errors && !loginForm.controls['password'].pristine">
                    <div [hidden]="!loginForm.controls['password'].errors.required" class="alert alert-danger">
                      Password is required.
                    </div>
                  </div>
                </div>

                <div class="row g-0 mb-3 captcha-cont">
                  <div class="col-md-6 d-flex align-items-center bg-light px-2">
                    <canvas id="myCanvas" width="130" height="40"></canvas>
                    <div class="p-2 cursor-pointer" (click)="generateCaptcha()" role="button" tabindex="0">
                      <svg width="16" height="16" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                        <path d="M17.65,6.35C16.2,4.9 14.21,4 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20C15.73,20 18.84,17.45 19.73,14H17.65C16.83,16.33 14.61,18 12,18A6,6 0 0,1 6,12A6,6 0 0,1 12,6C13.66,6 15.14,6.69 16.22,7.78L13,11H20V4L17.65,6.35Z"/>
                      </svg>
                    </div>
                  </div>
                  <div class="col-md-6 ps-2">
                    <input
                      autocomplete="off"
                      pattern="^[^<>]*$"
                      formControlName="captcha"
                      type="text"
                      class="form-control"
                      placeholder="Enter Captcha"
                      [attr.autocomplete]="'off'"
                    >
                  </div>
                </div>

                <div>
                  <div *ngIf="loginForm.controls['captcha'].errors && !loginForm.controls['captcha'].pristine">
                    <div [hidden]="!loginForm.controls['captcha'].errors.required" class="alert alert-danger">
                      Captcha is required.
                    </div>
                  </div>
                </div>

                <div>
                  <button type="submit"
                          class="btn btn-rounded w-75"
                          style="background-color: #fff; color: #00B06C; font-weight: 500;">
                    SIGN IN
                    <i *ngIf="isLoader" class="fa fa-spinner fa-spin"></i>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>
